import store from '../index';
import { combineReducersAsync } from './index';

const asyncReducers = {};

export default (name, asyncReducer) => {
  asyncReducers[name] = asyncReducer;
  store.replaceReducer(combineReducersAsync(asyncReducers));
};



// WEBPACK FOOTER //
// ./webpack/assets/javascripts/react_app/redux/reducers/registerReducer.js